module.exports = __webpack_public_path__ + "img/white_list.85eba9d1.svg";